import type {
  App,
  Component,
} from 'vue';
import {
  createApp,
} from 'vue';

let app: App | undefined;

export default function getApp(component?: Component): App {
  if (!app) {
    if (!component) {
      throw new Error('Please provide component');
    }

    app = createApp(component);
  }

  return app;
}
